/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';
import EditableLine from '@components/common/editableLine';
import Header from '@components/settings/v2/common/SettingsHeader';

import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { useManageEmailReports } from './hooks/useManageEmailReports';

const EmailReports = (props) => {
  const { C } = props;
  const { subscribeForWeeklyDigest, isLoading, toggleWeeklyDigest } = useManageEmailReports();

  return (
    <View key="mainMachineContent" style={{ height: '100%', width: '100%', backgroundColor: C('Background/Light/Detail'), alignItems: 'center' }}>
      <Header backBtnText="Notifications" name={'EmailReports'} />
      <View
        style={{
          width: '100%',
          paddingHorizontal: scale(18),
        }}
      >
        <View testID={TEST_IDS.settingsScreen.weeklyDigestToggle} style={[getBoxShadowStyle({ type: 'Field', C }), { borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
          <EditableLine
            {...{
              item: {
                value: subscribeForWeeklyDigest,
                name: 'Weekly Email Reports',
                noArrow: true,
                isLable: true,
                oneLine: true,
                small: false,
                width: 170,
                type: 'boolean',
                loading: isLoading,
                onChange: (v) => toggleWeeklyDigest(v),
              },
              index: 0,
              array: [{}],
              C,
              topBorder: false,
              bottomBorder: false,
              roundTop: true,
              roundBottom: true,
            }}
          />
        </View>
        <View>
          <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary'), paddingHorizontal: scale(15), marginTop: scale(3) }]}>
            {i18n.t("Receive email reports on every Monday about past week's peformance.")}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default ColorWrapper(EmailReports);
